import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';
import { CodelistResponce } from 'src/types/URLKeys';

export const codeListApi = createApi({
  baseQuery,
  reducerPath: 'codeListApi',
  endpoints: builder => ({
    getCodelist: builder.query<any, string>({
      query: code_list_code => ({
        url: formatString(endPoints.CodeList.select, {
          key: urlKeys.code_list_code,
          value: code_list_code
        }),
        extraOptions: { maxRetries: 3 }
      }),
      transformResponse: (response: CodelistResponce) => response?.selected_data ?? []
    })
  })
});

export const { useGetCodelistQuery } = codeListApi;
